"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSolanaTransaction = useSolanaTransaction;
var react_1 = require("react");
var useConnection_1 = require("./useConnection");
/**
 * Hook for tracking transaction status with confirmations
 *
 * @param signature Transaction signature to track
 * @param autoFetch Whether to automatically fetch transaction status
 * @returns Transaction status information and functions
 */
function useSolanaTransaction(signature, autoFetch) {
    var _this = this;
    if (autoFetch === void 0) { autoFetch = true; }
    var dualConnection = (0, useConnection_1.useConnection)().connection;
    // Cast to legacy Connection for existing code compatibility
    var connection = dualConnection;
    var _a = (0, react_1.useState)(null), txStatus = _a[0], setTxStatus = _a[1];
    var _b = (0, react_1.useState)(false), loading = _b[0], setLoading = _b[1];
    var fetchStatus = (0, react_1.useCallback)(function () { return __awaiter(_this, void 0, void 0, function () {
        var status, transactionDetails, e_1, txStatus_1, error_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!signature) {
                        setTxStatus(null);
                        return [2 /*return*/];
                    }
                    setLoading(true);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 7, 8, 9]);
                    return [4 /*yield*/, connection.getSignatureStatus(signature, {
                            searchTransactionHistory: true,
                        })];
                case 2:
                    status = _c.sent();
                    transactionDetails = void 0;
                    if (!(((_a = status.value) === null || _a === void 0 ? void 0 : _a.confirmationStatus) === 'confirmed' ||
                        ((_b = status.value) === null || _b === void 0 ? void 0 : _b.confirmationStatus) === 'finalized')) return [3 /*break*/, 6];
                    _c.label = 3;
                case 3:
                    _c.trys.push([3, 5, , 6]);
                    return [4 /*yield*/, connection.getTransaction(signature, {
                            maxSupportedTransactionVersion: 0
                        })];
                case 4:
                    transactionDetails = _c.sent();
                    return [3 /*break*/, 6];
                case 5:
                    e_1 = _c.sent();
                    return [3 /*break*/, 6];
                case 6:
                    if (status.value) {
                        txStatus_1 = {
                            signature: signature,
                            status: status.value.err ? 'failed' :
                                (status.value.confirmationStatus === 'finalized' ? 'finalized' :
                                    status.value.confirmationStatus === 'confirmed' ? 'confirmed' : 'pending'),
                            confirmations: status.value.confirmations || 0,
                            confirmationStatus: status.value.confirmationStatus || 'processed',
                            error: status.value.err ? JSON.stringify(status.value.err) : undefined,
                            transactionDetails: transactionDetails || undefined,
                        };
                        setTxStatus(txStatus_1);
                    }
                    else {
                        setTxStatus({
                            signature: signature,
                            status: 'pending',
                            confirmations: 0,
                            confirmationStatus: undefined,
                        });
                    }
                    return [3 /*break*/, 9];
                case 7:
                    error_1 = _c.sent();
                    console.error('Error fetching transaction status:', error_1);
                    setTxStatus({
                        signature: signature,
                        status: 'failed',
                        confirmations: 0,
                        confirmationStatus: undefined,
                        error: error_1.message,
                    });
                    return [3 /*break*/, 9];
                case 8:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 9: return [2 /*return*/];
            }
        });
    }); }, [connection, signature]);
    // Latest status, read inside the scheduler without re-triggering the effect.
    var txStatusRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        txStatusRef.current = txStatus;
    }, [txStatus]);
    // Poll with exponential backoff and stop on terminal status.
    // Previously this was setInterval(fetchStatus, 2000) — it kept hitting
    // the RPC twice every 2s forever, including after finalisation, which
    // tripped rate limits on hosted RPC providers.
    (0, react_1.useEffect)(function () {
        if (!autoFetch || !signature)
            return;
        var BACKOFF_MS = [1000, 2000, 5000, 10000, 30000];
        var cancelled = false;
        var timeoutId = null;
        var attempt = 0;
        var tick = function () { return __awaiter(_this, void 0, void 0, function () {
            var current, delay;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (cancelled)
                            return [2 /*return*/];
                        return [4 /*yield*/, fetchStatus()];
                    case 1:
                        _a.sent();
                        if (cancelled)
                            return [2 /*return*/];
                        current = txStatusRef.current;
                        if (current && (current.status === 'finalized' || current.status === 'failed')) {
                            return [2 /*return*/];
                        }
                        delay = BACKOFF_MS[Math.min(attempt, BACKOFF_MS.length - 1)];
                        attempt += 1;
                        timeoutId = setTimeout(tick, delay);
                        return [2 /*return*/];
                }
            });
        }); };
        void tick();
        return function () {
            cancelled = true;
            if (timeoutId !== null)
                clearTimeout(timeoutId);
        };
    }, [autoFetch, fetchStatus, signature]);
    return {
        status: txStatus,
        loading: loading,
        refetch: fetchStatus
    };
}
